import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import * as _ from 'underscore';
import { Observable } from 'rxjs';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { BiUrls } from '../../biUrls';
import { HttpResponse, HttpHeaders } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { e } from '@angular/core/src/render3';

@Component({
    selector: 'dimLvlPermissions',
    templateUrl: 'dimLvlPermissions.component.html'
})

export class dimLvlPermComponent {

    @ViewChild('file')
    fileInput: ElementRef;
    @ViewChild('dimAutoComplete') dimAutoComplete: ElementRef;
    public mainPage: boolean = true;
    public searchButton: boolean = false;
    public accessDenied: boolean = false;
    public saveButton: boolean = false;
    public isEdit: boolean = false;
    public loader: boolean = false;
    public uploadSucess: boolean = false;
    public add: boolean = false;
    public uploadedDataList: any = [];
    public removedDataList: any = [];
    public nonExistentDimensions: any = [];
    public nonExistentDimLevels: any = [];
    public nonExistentUsers: any = [];
    public nonExistentScopes: any = [];
    public nonExistentAccess: any = [];
    public file: any = null;
    public formdata: FormData;
    public totalEODR: number = 0;
    public totalPages: number = 0;
    public totalEmps: number = 0;
    public totalLevels: number = 0;
    public totalDimLevel: number = 0;
    public page: number = 0;
    public size: number = 10;
    public currentPage: number = 1;
    public startingPage: number = 0;
    public endingPage: number = 0;
    public pageSize: number = 10;
    public dimList: any = [];
    public dim: any;
    public employeeList: any = [];
    public employeePageData: any = [];
    public empIdList: any = [];
    public employeeOrg: any = [];
    public selectedEmployee: any;
    public levelName: any;
    public values: string = "";
    public query: any;
    public dimLevels: any = [];
    public dimensionLevelId: number;
    public selectedDimension: any = "selectOne";
    public filteredDimensionMap = new Map();
    public scope: any;
    public deleteArray: any = [];
    public filteredList: any = [];
    public employeeOrgRelations: any = [];
    public empOrgList: any = [];
    public dimPermList: any = [];
    public referencevariable: String = 'none';
    public selectedDimLevel: any;
    public employeeId: any;
    public dimValue: any;
    public dimLvlValList: any = [];
    public scopeList: any = [];
    public dimensionMap = new Map();
    public dimensionData: any = {
        id: null, name: '', description: '', dimTime: null, deleted: 0, dimHierarchyData: []
    };

    public timeInterval: number;
    public progress: number = 0;
    public token: any;
    public isProgress: boolean = false;
    public count = 0;
    public selectedDimensionLevel: any;
    public selecteDimensionValue: any;
    public scopeMap = new Map();

    public empOrgData: any = {
        employeeId: null,
        orgDimension: null,
        orgDimensionValue: "",
        scope: null,
        orgDimensionLevel: null,
        orgDimensionLevelName: "",

    };

    public tabs: any = ['Individual', 'Bulk'];
    public selectedTab = this.tabs[0];

    public searchData = {
        "nameOrCodeOrEmail": "",
        "employeeCodes": [],
        "excludedEmployeeCodes": [],
        "includeEmpIds": [],
        "excludeEmpIds": [],
        "gradeIds": [],
        "mgrLevelIds": [],
        "designationIds": [],
        "categoryIds": [],
        "includeOrgIds": [],
        "excludeOrgIds": [],
        "supervisorIds": [],
        "primarySupervisorIds": [],
        "primarySupervisorNameOrCode": null,
        "primarySupervisorCods": [],
        "employeeStatus": null,
        "employeesWithOutSupervisor": null,
        "scorecardStates": null,
        "memberShipState": null,
        "programId": null,
        "pageSize": 10,
        "page": 1,
        "fetchSupervisorLevels": 0
    }


    // public dimensionHierachyData: any = {
    //     id: null,
    //     dimName: "",
    //     dimLevelName: "",
    //     dimValues: "",
    //     scope: "",
    //     dimId: "",
    // };

    // public scopeArray: any = [
    //     { value: 1, name: 'Team' },
    //     { value: 2, name: 'Individual' },
    //     { value: 3, name: 'All' },
    //     { value: 4, name: 'Custom 4' },
    //     { value: 5, name: 'Custom 5' },
    //     { value: 6, name: 'Custom 6' },
    //     { value: 7, name: 'Custom 7' },
    //     { value: 8, name: 'Custom 8' },
    //     { value: 9, name: 'Custom 9' },
    //     { value: 10, name: 'Custom 10' }
    // ];

    public authPageNo: number = 0;
    public authPageSize: number = 10;
    public authStartingPage: number = 0;
    public authEndingPage: number = 10;
    public authCurrentPage: number = 1;
    public authTotalRecs: number = 0;

    public tableData: any = [];
    public comment: any = '';
    private fileNameToUpload: any = null;

    public selectedDimensionName: any;
    public selectedDimensionLevelName: any;
    public selectedEmpDimLevelId: any;

    @ViewChild('autoCompletediv') elementDiv: ElementRef;

    constructor(public dimLvlPermService: MDMService, public _sanitizer: DomSanitizer
        , public toastr: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr)
    }

    ngOnInit() {
        if (this.dimLvlPermService.isBIAdmin) {
            this.mainPage = true;
            this.loadScopes();
            this.loadDimensions();
            this.loadEmployees();
        } else {
            this.accessDenied = true;
        }
    }

    loadScopes() {
        let self = this;
        self.dimLvlPermService.onStartUp(BiUrls.SCOPE).then(res => {
            if (res != undefined) {
                self.scopeList = res.data;
                this.loadScopesIntoMap();
            }
        })
    }

    loadScopesIntoMap(){
        this.scopeList.forEach((scope) => {
            this.scopeMap.set(scope.id, scope.name);
        })
    }

    // scopeData(num) {
    //     for (let scopes of this.scopeArray) {
    //         if (scopes.value == num) {
    //             return scopes.name;
    //         }
    //     }
    //     return '';
    // }

    onBack() {
        this.mainPage = true;
        this.isEdit = false;
    }

    bulkUpload(event) {
        let self = this;
        if (self.validateFile(self.file)) {
            let formdata1 = new FormData();
            self.loader = true;
            formdata1.append("file", self.file);
            self.dimLvlPermService.bulkUpload(BiUrls.PAGE, BiUrls.BULKUPLOAD_DIM_LVL_PERMISSION, formdata1).then(res => {
                if (res) {
                    if (!(res instanceof Object)) {
                        res = JSON.parse(res);
                    }
                    if (res.success) {
                        self.token = res.data;
                        if (self.token) {
                            self.isProgress = true;
                            setTimeout(() => {
                                self.checkProgress();
                            }, self.timeInterval * 1000);
                        }
                    } else {
                        self.toastr.showError(res.errorMessage);
                    }
                    self.loadScopes();
                    // self.loadDimensions();
                    self.loadEmployees();
                }
                self.loader = false;
            }, error => {
                console.log(error);
            });
        } else {
            self.toastr.showError('Please Attach An Excel File');
        }
    }

    public validateFile(file) {
        let ext;
        if (file != null) {
            ext = file.name.split('.', 2);
        } else {
            ext = undefined;
        }
        if (ext == undefined || !(ext[1].toLowerCase() == 'xls' || ext[1].toLowerCase() == 'xlsx')) {
            return false;
        } else {
            return true;
        }
    }

    public checkProgress() {
        let self = this;
        if (self.count == 10) {
            self.count = 0;
            self.progress = 0;
            self.isProgress = false;
            self.toastr.showError("Bulk Upload Failed");
            return;
        }
        this.dimLvlPermService.getProgress(self.token, 'trackProgress/bi_bulk_dimLvlPerm_/').then(res => {
            if (res && res.success) {
                if (Math.round(+res.data) == self.progress) {
                    self.count += 1;
                }
                self.progress = Math.round(+res.data);
                if (self.progress < 100) {
                    setTimeout(() => {
                        self.checkProgress();
                    }, self.timeInterval * 1000);
                } else if (self.progress == 100) {
                    self.isProgress = false;
                    self.dimLvlPermService.getProgress(self.token, 'statusReport/bi_bulk_dimLvlPerm_/').then(res => {
                        self.progress = 0;
                        self.uploadSucess = true;
                        self.file = null;
                        self.fileInput.nativeElement.value = null;
                        self.toastr.showSuccess("Bulk Upload Successful");
                        self.loadUploadReport(res);
                    });
                }
            }
        });
    }

    loadUploadReport(result) {
        let self = this;
        let statusMap = this.jsonToMap(result);
        this.nonExistentUsers = statusMap.get("NON_EXISTENT_EMPLOYEES");
        this.nonExistentDimensions = statusMap.get("NON_EXISTENT_DIMENSIONS");
        this.nonExistentDimLevels = statusMap.get("NON_EXISTENT_DIM_LEVELS");
        this.nonExistentScopes = statusMap.get("NON_EXISTENT_SCOPES");
        this.nonExistentAccess = statusMap.get("NON_EXISTENT_ACCESS");
        this.uploadedDataList = statusMap.get("UPLOADED_DATA");
        this.removedDataList = statusMap.get("REMOVED_DATA");
    }

    jsonToMap(result: any) {
        let res = result;
        let jsonObj = JSON.parse(JSON.stringify(res.data));
        let map = new Map();
        for (let k of Object.keys(jsonObj)) {
            map.set(k, jsonObj[k]);
        }
        return map;
    }

    onScopeSelect(event) {
        this.scope = event.target.value;
    }

    fileChange(event) {
        let size = +event.target.files[0].size / (1024 * 1024);
        if(size < 1){
            this.timeInterval = 1; // less then 1 MB
        } else if(size < 5){
            this.timeInterval = 2; // less then 5 MB
        } else if(size < 10){
            this.timeInterval = 3; // less then 10 MB
        }else if(size > 10){
            this.timeInterval = 5; // greater then 10 MB
        }
        this.file = event.target.files[0];
    }

    public loadDimensions() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;

            self.dimLvlPermService.onStartUp(BiUrls.DIMENSION).then((res) => {
                self.dimList = [];
                self.totalPages = 0;
                if (res != undefined) {
                    self.dimList = res.data != undefined &&
                        res.data != undefined ? res.data :
                        self.toastr.showError('No results found');
                }
                if (self.dimList && self.dimList.length > 0) {
                    self.dimList.forEach(dim => {
                        self.dimensionMap.set(dim.id, dim);
                    });
                }
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, (err) => {
                console.error(err);
            });
        });
    }

    public loadEmpOrgDim() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.dimLvlPermService.onStartUp(BiUrls.DIM_LVL_PERMISSION + '/' + self.employeeId).then(
                (res) => {
                    self.empOrgList = res != undefined && res.data != undefined ? res.data : [];
                    self.setEmpOrgList();
                    self.saveButton = false;
                    self.loader = false;
                    self.mainPage = true;
                    resolve('completed');
                }, (err) => {
                    console.error(err);
                });
        });
    }

    setEmpOrgList() {
        let self = this;
        self.dimPermList = [];
        for (let eodr of self.empOrgList) {

            let dimPermData = { id: '', dimName: '', dimLvlName: '', dimLvlVal: '', scope: '' };
            let dimLvlVal = eodr.orgDimensionValue;
            let dim = self.dimList.filter(d => d.id == eodr.orgDimension);
            //let dimLvlId = self.getDimDataParts(dimLvlVal, 'dimLvlId');

            if (!dim[0]) {
                continue;
            }

            let dimLvl = dim[0].dimHierarchyData[0].dimHierarchyLevelData.filter(dl => dl.id == Number(eodr.orgDimensionLevel));

            if (dimLvl[0] != undefined) {
                dimPermData.dimName = dim[0].displayName;
                dimPermData.dimLvlName = dimLvl[0].displayName;
                dimPermData.dimLvlVal = self.getDimDataParts(dimLvlVal, 'dimLvlVal');
                let scope = self.scopeList.filter(scp => scp.id == eodr.scope);
                dimPermData.scope = scope[0] ? scope[0].name : '';
                dimPermData.id = eodr.id;
                self.dimPermList.push(dimPermData);
            }

        }
    }

    getDimDataParts(dimStr, type) {
        let self = this;
        let dimParts = dimStr.split('].[');
        if (type == 'dim') {
            return dimParts[0].substr(1);
        } else if (type == 'dimLvlVal') {
            return dimParts[2].slice(0, -1);
        } else {
            return dimParts[1];
        }
    }

    public loadEmployees() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            let url = BiUrls.PAGE + BiUrls.ALL_P_EMPLOYEES;
            self.employeeId = null;
            self.dimPermList = [];
            self.dimLvlPermService.getDataByPage(url, self.page, self.pageSize).then(
                (res) => {
                    self.employeeList = [];
                    self.empIdList = [];
                    if (res == undefined) {
                        self.toastr.showError('Cannot load the Employee Data');
                    } else {
                        self.employeeList = res.data.pageElements != undefined ?
                            res.data.pageElements.length == 0 ?
                                self.toastr.showWarning('No Employees to load') :
                                res.data.pageElements :
                            self.toastr.showError('No Employees found');
                        self.totalEmps = res.data.total;
                        self.setEndingPage(self.totalEmps);
                        for (let emp of self.employeeList) {
                            self.empIdList.push(emp.id);
                        }
                    }
                    self.loader = false;
                    self.mainPage = true;
                    resolve('completed');
                }, (err) => {
                    console.error(err);
                });
        });
    }

    onDimensionSelection(event) {
        let value = event.dimId ? event.dimId : event.id;
        let self = this;
        self.dim = value;
        self.selectedDimLevel = event.dimHierarchyLevelId;
        // this.dimLevels = [];
        // this.dimLvlValList = [];
        // if (this.levelName != null) {
        //     this.levelName = "";
        // }
        this.selectedDimension = event;
        // if (this.selectedDimension != "selectOne") {
        //     self.dimLevels = self.dimensionMap.get(+value).dimHierarchyData[0].dimHierarchyLevelData
        //     self.selectedDimensionName = event.name;
        //     self.dimLevels = _.sortBy(self.dimLevels, function (s) {
        //         return self.getDecodedValue(s.displayName).charCodeAt();
        //     });
        // }
        // this.onDimensionLevelSelect(event.dimHierarchyLevelId);
        this.dimAutoComplete.nativeElement.value = '';
    }

    public onDimensionLevelSelect(event) {
        console.log("inside dimension level select")
        let self = this;
        // let value = event.target.value;
        let value = event;
        this.elementDiv.nativeElement.value = null;
        self.filteredList = [];
        self.dimLvlValList = [];
        self.selectedDimLevel = value;
        if (self.selectedDimLevel != 'selectOne') {
            self.dimLevels.filter((item) => {
                if (item.id == value) {
                    self.selectedDimensionLevelName = item.displayName;
                }
            });

            let dimValObj = {
                "trendNeeded": false,
                "dimensionYAxis": [
                    { "dimension": { "id": self.dim }, "level": { "id": self.selectedDimLevel } }
                ]
            };
            self.dimLvlPermService.getDimLevelValues(dimValObj).then((res) => {
                self.dimLvlValList = (res.response != undefined && res.response.data != undefined) ? res.response.data : [];
            });
        } else {
            self.toastr.showError('Please Select Dimension Level');
        }
    }

    public getDimLvlVal = (keyword: any): Observable<any[]> => {
        let self = this;
        let request: any = { trendNeeded: false };
        request.dimensionYAxis = [{ "dimension": { "id": self.selectedDimension.dimId ? self.selectedDimension.dimId : self.selectedDimension.id }, "level": { "id": self.selectedDimLevel } }];
        if (self.selectedDimension == 'selectOne') {
            self.toastr.showError("Select Dimension to add values!");
            return;
        }
        if (keyword) {
            request.keyword = keyword;
            request.limit = 50;
            return Observable.create((observer: any) => {
                self.dimLvlPermService.dimensionData(request).then(function (res) {
                    if (res.response) {
                        observer.next(res.response.data);
                    } else {
                        observer.next([])
                    }
                    observer.complete();
                }, err => {
                    observer.next([]);
                    observer.complete();
                })
            })
        } else {
            return Observable.of([]);
        }
        // if (keyword != '') {
        //     self.filteredList = self.dimLvlValList.filter((dlv) => dlv.name.toLowerCase().includes(keyword.toLowerCase()));
        // } else {
        //     self.filteredList = [];
        // }
        // return Observable.of(self.filteredList);
    }

    autoCompleteListFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.name}</span>`;
        //let html = `<span> ${data.dimName} -- ${data.dimCode}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);

    }

    orgNameValueFormatter(data: any): string {
        return `${data.name}`;
    }

    public dimListFormatter = (data: any): SafeHtml => {
        let name = data.name ? data.name : data.dimHierarchyLevelName ? data.dimHierarchyLevelName : data.dimName;
        // let code = data.metadata ? data.metadata.d_l_id : data.dimHierarchyLevelId ? data.dimHierarchyLevelId : data.dimCode;
        let html = `<span>${name} -- ${data.dimCode}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public dimValueFormatter = (data: any): string => {
        let name = data.name ? data.name : data.dimHierarchyLevelName ? data.dimHierarchyLevelName : data.dimName;
        let html = `${name}`;
        return html;
    }

    public searchDim = (keyword: any): Observable<any[]> => {
        let self = this;
        if (keyword) {
            return self.dimLvlPermService.search1(BiUrls.BI_DIMENSION, BiUrls.SEARCH_DIMENSION, keyword);
        } else {
            return Observable.create((observer: any) => {
                observer.next([]);
                observer.complete();
            })
        }
    }

    public onSelectDimLvlVal(event) {
        let self = this;
        self.selecteDimensionValue = event;
        self.dimValue = event.key;
        self.elementDiv.nativeElement.value = '';
    }

    getDecodedValue(encodedText) {
        if (!encodedText) return "";
        let x: any;
        x = document.createElement("TEXTAREA");
        x.innerHTML = encodedText;
        return x.value;
    }

    public loaderControl(event) {
        this.loader = event;
    }

    public employeesFound(event) {
        this.employeeList = event;
    }

    public pageDataControl(event) {
        this.employeePageData = event;
        this.totalEmps = event.totalElements;
        this.setEndingPage(this.totalEmps);
    }

    public onSelectEmployee(event) {
        this.employeeId = event.target.id;
        this.loadEmpOrgDim();
    }

    public onPageChange(event: number): void {
        console.log('On Page Change Controller ...');
        this.currentPage = event;
        this.page = this.currentPage - 1;
        this.searchData.page = event;
        this.getEmployee();
        this.setEndingPage(this.totalEmps);

    }

    public OnPageSizeChanged(event) {
        console.log('On Page-Size Change Controller ...');
        this.pageSize = event.target.value;
        this.searchData.pageSize = this.pageSize;
        this.getEmployee();
        this.setEndingPage(this.totalEmps);
    }



    onClickOfAdd() {
        let self = this;
        let validate: any = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        } else {
            if(this.isDuplicateDimensionFilter()) {
                this.toastr.showError("Dimension Filter Already Exists");
                return;
            }

            self.saveButton = true;
            self.loader = true;
            self.empOrgData.employeeId = self.employeeId;
            self.empOrgData.orgDimension = self.selectedDimension.dimId ? self.selectedDimension.dimId : self.selectedDimension.id ;
            self.empOrgData.scope = self.scope;
            self.empOrgData.orgDimensionLevel = Number(self.selectedDimLevel);
            self.empOrgData.orgDimensionValue = self.dimValue;

            self.dimLvlPermService.save(BiUrls.DIM_LVL_PERMISSION, self.empOrgData).then(function (success: any) {
                if ((success.errorMessage != null || success.errorMessage != undefined)) {
                    console.log(success.errorMessage);
                    self.mainPage = false;
                    self.accessDenied = true;
                    self.add = false;
                    return;
                }
                if (success.message) {
                    console.log(success.message);
                    self.toastr.showError(success.message);
                    self.resetDimLvlValues();
                    self.saveButton = false;
                    self.loader = false;
                    return;
                }

                self.toastr.showSuccess('Dimension Filter Added successfully');
                self.loadEmpOrgDim();
                self.employeeOrgRelations = success;
                self.resetDimLvlValues();
                self.loader = false;
            },
                function (error) {
                    self.toastr.showError('Failed to add Dimension Filter');
                    console.log(error);
                }
            );
        }
    }

    resetDimLvlValues() {
        let self = this;
        // self.employeeId = null;
        self.selectedDimension = "selectOne";
        self.selectedDimLevel = undefined;
        self.dimValue = undefined;
        self.filteredList = [];
        self.dimLevels = [];
        self.scope = null;
        self.elementDiv.nativeElement.value = null;
        self.selecteDimensionValue = null;
    }

    validater() {
        //if (this.employeeOrgRelations.length == 0 || this.selectedEmployee == null || this.selectedEmployee == "selectOne") {
        if (this.employeeId == undefined) {
            return 'Please select the Employee for further actions';
        }
        //if (this.dimArray == null || this.dimArray == undefined || this.selectedDimension == "selectOne") {
        if (this.selectedDimension == "selectOne") {
            return 'Please select dimension to add the permission';
        }
        if (this.selectedDimLevel == undefined) {
            return 'Please select dimension level to add the permission';
        }
        if (this.dimValue == undefined || this.dimValue.trim() == '') {
            return 'Please select dimension level value to add the permission';
        }
        if (this.scope == undefined) {
            return 'Please select scope to add the permission';
        }
        return '';
    }

    isDuplicateDimensionFilter() {
        let self = this;
        let isDuplicate = false;
            for(let dimPerm of self.dimPermList) {
                if(dimPerm.dimName == self.selectedDimension.dimDisplayName && 
                    dimPerm.dimLvlName == self.selectedDimension.dimHierarchyLevelName &&
                    dimPerm.dimLvlVal == self.selecteDimensionValue.name &&
                    dimPerm.scope == self.scopeMap.get(Number(self.scope))) {
                    isDuplicate = true;
                    break;
                }
            }
        return isDuplicate;
    }

    // setOrgData() {
    //     let orgData = this.empOrgData;
    //     orgData.employeeId = this.selectedEmployee;
    //     orgData.orgDimensionValue = this.values;
    //     //orgData.orgDimension = this.dimArray.id;
    //     orgData.scope = this.scope;
    //     orgData.orgDimensionLevel = this.dimensionLevelId;
    //     orgData.orgDimensionLevelName = this.levelName;
    //     return orgData;
    // }

    validationBeforeSaving(orgData, levelName, values) {
        let msg = "Please Select all the fields to add the permission"
        if (orgData.employeeId == null) {
            return msg;
        }
        if (orgData.orgDimension == "") {
            return msg;
        }
        if (levelName == undefined || levelName == "" || levelName == "selectOne") {
            return msg;
        }
        if (values == "selectOne" || values == "") {
            return msg;
        }
        if (orgData.scope == undefined || orgData.scope == 0 || orgData.scope == "selectOne") {
            return msg;
        }
        return "";
    }

    // getEmployeeOrgRelation(event) {
    //     let self = this;
    //     self.employeeOrg = [];
    //     if (typeof event != 'object') {
    //         self.selectedEmployee = event;
    //     } else {
    //         self.selectedEmployee = event.target.value;
    //     }

    //     if (self.selectedEmployee == "selectOne") {
    //         return;
    //     }
    //     if (self.selectedEmployee != "selectOne") {
    //         self.dimLvlPermService.getDataById(BiUrls.DIM_LVL_PERMISSION, this.selectedEmployee).then((res) => {

    //             for (let employee of self.employeeOrgRelations) {
    //                 if (employee.orgDimensionValue != undefined || employee.orgDimensionValue != null) {
    //                     let dimLevels = employee.orgDimensionValue.split('].[')

    //                     let dimensionHierachyData = self.empOrgData
    //                     dimensionHierachyData.id = employee.id;
    //                     dimensionHierachyData.scope = self.scopeData(employee.scope);
    //                     dimensionHierachyData.dimName = dimLevels[0].slice(1);
    //                     dimensionHierachyData.dimLevelName = employee.orgDimensionLevelName;
    //                     dimensionHierachyData.dimValues = dimLevels[dimLevels.length - 1].slice(0, dimLevels[dimLevels.length - 1].length - 1);
    //                     self.employeeOrg.push(dimensionHierachyData);
    //                 }
    //             }
    //         },
    //             function (error) {
    //                 console.log(error);
    //             }
    //         );
    //     }
    // }

    onSelectToDelete(event) {
        if (event.target.checked == true) {
            this.deleteArray.push(Number(event.target.id));
        }
        else if (event.target.checked == false) {
            let index = this.deleteArray.indexOf(Number(event.target.id));
            this.deleteArray.splice(index, 1);
        }
        return this.deleteArray;
    }

    deleteConfirm(event) {
        if (this.deleteArray.length == 0) {
            return;
        }
        let decision = confirm('Do you want remove this permission?');
        if (decision == true) {
            this.onDelete(event);
        }
    }

    onDelete(event) {
        let self = this;
        self.loader = true;
        let url = BiUrls.DIM_LVL_PERMISSION + BiUrls.REMOVE_MULTIPLE_DIM_LVL_PERMSSIONS;
        self.dimLvlPermService.deleteEmpOrgDimRel(url, self.deleteArray).then((response) => {
            self.toastr.showSuccess('Dimension level permissions removed successfully');
            self.deleteArray = [];
            self.loadEmpOrgDim();
            self.loader = false;
        }, (err) => {
            self.toastr.showError('Unable to remove dimension level permissions : ' + err.errorCode);
        });
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    }

    showSearchFilter(event) {
        this.searchData = event;
        this.searchData.page = 1;
        this.getEmployee();
    }

    getEmployee() {
        try {
            let self = this;
            self.loader = true;
            self.dimLvlPermService.getEmployee(this.searchData).then((result) => {
                self.empIdList = [];
                self.employeeList = result.content;
                self.employeePageData = result;
                self.totalEmps = result.totalElements;
                self.setEndingPage(self.totalEmps);
                self.loader = false;
            });
        } catch (e) {
            console.log("getAllEmployeeData error catch", e);
        }
    }

    removeDimSelected() {
        this.selectedDimension = 'selectOne';
        this.selecteDimensionValue = null;
    }

    removeDimValue() {
        this.selecteDimensionValue = null;
    }

    beforeChange(event) {
        if (event.nextId == 'individual') {
            this.selectedTab = event.nextId;
        } else if (event.nextId == 'bulk') {
            this.selectedTab = event.nextId;
            this.getUserDimRelsHistory();
        }
    }

    private chooseFile(event) {
        if (event.target.files && event.target.files.length > 0) {
            let self = this;
            this.file = event.target.files[0];
            self.fileNameToUpload = event.target.files[0].name;
            event.srcElement.value = null;
        }
    }

    public validateBulkOpInput() {
        let self = this;
        let ext = self.file.name.split('.', 2);
        let isValid = true;

        if (ext[1].toLowerCase() != 'xlsx') {
            this.toastr.showError("Please Attach An Excel File");
            isValid =  false;
        }

        if (self.comment.trim() === '') {
            this.toastr.showError("Comment is mandatory");
            isValid =  false;
        }

        return isValid;
    }

    public initBulkUserDimRels(event) {
        let self = this;
        let formdata = new FormData();
        if (self.validateBulkOpInput()) {
            self.loader = true;
            formdata.append('file', self.file);
            formdata.append('comment', self.comment);
            self.dimLvlPermService.bulkUpload('auth/', 'processBulkUserDimRel', formdata).then((res) => {
                if (res) {
                    if(res.status == 409) {
                        self.toastr.showError(JSON.parse(res.error).message);
                    } else {
                        if (!(res instanceof Object)) {
                            res = JSON.parse(res);
                        }
                        if (res.success) {
                            self.uploadSucess = true;
                            self.file = null;
                            self.fileInput.nativeElement.value = null;
                            self.token = res.data;
                            self.isProgress = true;
                        } else {
                            self.toastr.showError(res.errorMessage);
                        }
                    }

                    self.getUserDimRelsHistory();
                }
                self.loader = false;
                self.resetBulkOperationParams();
            }, (err) => {
                console.error(err);
                self.resetBulkOperationParams();
                self.loader = false;
            });
        }
    }

    private resetBulkOperationParams() {
        this.comment = '';
        this.fileNameToUpload = null;
    }

    private downloadFiles(url) {
        try {
            this.dimLvlPermService.mdmService.getBlob(url).subscribe((result: HttpResponse<Blob>) => {
                let name = this.getFileNameFromHeader(result.headers);
                FileSaver.saveAs(result.body, name);
            });
        } catch (e) {
            console.log('download error caught', e);
        }
    }

    private downloadTemplate() {
        let url = this.dimLvlPermService.base_url + 'biAdmin/auth/downloadTemplate/USER_DIMENSION_FILTER_TEMPLATE';
        this.downloadFiles(url);
    }

    private downloadUserDimRelsFiles(filePath) {
        let url = this.dimLvlPermService.base_url + 'biAdmin/auth/downloadFile/' + filePath;
        this.downloadFiles(url);
    }

    private getFileNameFromHeader(headers: HttpHeaders): string {
        let header = headers.get('Content-Disposition');
        if (header == null) {
            return 'User_Dimension_Filter_Template.xlxs';
        } else {
            if (!header) {
                return null;
            }
            let result: string = header.split(';')[1].trim().split('=')[1];
            return result.replace(/'/g, '');
        }
    }

    private getUserDimRelsHistory() {
        let self = this;
        try {
            let url = self.dimLvlPermService.base_url +
                'biAdmin/auth/getAllUploadStatus/?processType=BI_USER_DIM_FILTER_UPLOAD&' +
                'page=' + self.authCurrentPage + '&pageSize=' + self.authPageSize;
            self.dimLvlPermService.mdmService.get(url).subscribe((response) => {
                this.handleUserDimRelsHistoryResponse(response);
            });
        } catch (e) {
            console.log('Error: getUserDimRelsHistory', e);
        }
    }

    private handleUserDimRelsHistoryResponse(response) {
        if (response && response.content) {
            this.authTotalRecs = response.totalElements;
            this.tableData = response.content;
            this.setPaginationParams();
        }

    }

    public setPaginationParams() {
        let self = this;
        if (self.authCurrentPage == 1) {
            self.authStartingPage = 0;
            if (self.authTotalRecs > self.authPageSize) {
                self.authEndingPage = self.authPageSize;
            } else {
                self.authEndingPage = self.authTotalRecs;
            }
        } else {
            self.authStartingPage = 0 + ((self.authCurrentPage - 1) * + self.authPageSize);
            self.authEndingPage = + self.authPageSize + ((self.authCurrentPage - 1) * + self.authPageSize);
            if (self.authEndingPage > self.authTotalRecs) {
                self.authEndingPage = self.authTotalRecs;
            }
        }
    }

    private onAuthHistoryPageSizeChanged(event) {
        this.authPageSize = event.target.value;
        this.getUserDimRelsHistory();
    }

    public onAuthHistoryPageChange(event: number): void {
        if (typeof event == 'number' && !isNaN(event)) {
            this.authCurrentPage = event;
            this.getUserDimRelsHistory();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dimLvlPermissions.component.ts